/* eslint-disable camelcase */
import { fetchList } from '@/api/course'

const state = {
  list: [],
  items: [],
}

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list
  },
  SET_ITEMS: (state, items) => {
    state.items = items
  },
}

const actions = {
  list({ commit }) {
    return new Promise((resolve, reject) => fetchList({
      page: 0,
      limit: 0,
      orderBy: 'CourseName',
      orderDesc: false,
    })
      .then(response => {
        console.log('store list response', response)
        const { data } = response
        commit('SET_LIST', data.items)
        const items = []
        data.items.forEach(item => items.push({
          itemValue: item.id,
          itemName: `${item.id}`,
          label: `${item.courseName}`,
        }))
        commit('SET_ITEMS', items)
        resolve(data)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
